import { container } from 'tsyringe';
import { CreateBookingV3ApiRepository } from '../../repositories/api/CreateBookingV3ApiRepository';
import ApiService from '../../services/ApiService';
import { CreateBookingV3Mapper } from '@/data/persistences/mappers/CreateBookingV3Mapper';
import { CreateBookingV3Endpoint } from '../../endpoints/CreateBookingV3Endpoint';
import { CreateBookingV3Presenter } from '@/app/ui/presenters/CreateBookingV3Presenter';

export class CreateBookingV3Component {
  public static init() {
    container.register<CreateBookingV3ApiRepository>(CreateBookingV3ApiRepository, {
      useFactory: d => {
        return new CreateBookingV3ApiRepository(
          d.resolve(ApiService),
          d.resolve(CreateBookingV3Mapper),
          d.resolve(CreateBookingV3Endpoint)
        )
      }
    });
    container.register<CreateBookingV3Mapper>(CreateBookingV3Mapper, {
      useClass: CreateBookingV3Mapper
    });
    container.register<CreateBookingV3Presenter>(CreateBookingV3Presenter, {
      useFactory: d => {
        return new CreateBookingV3Presenter(
          d.resolve(CreateBookingV3ApiRepository)
        )
      }
    });
  }
}

